import { render, staticRenderFns } from "./tab_media_sosial.vue?vue&type=template&id=b6a9332c&scoped=true"
import script from "./tab_media_sosial.vue?vue&type=script&lang=js"
export * from "./tab_media_sosial.vue?vue&type=script&lang=js"
import style0 from "./tab_media_sosial.vue?vue&type=style&index=0&id=b6a9332c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a9332c",
  null
  
)

export default component.exports